module.exports = __webpack_public_path__ + "img/p.d7594879.jpg";